import cloneDeep from 'lodash.clonedeep';

const DEFAULT_STROKE_CONFIG = {
  width: [2, 2, 2, 2, 2],
};

const ChartConfigPropertyKey = {
  Width: 'width',
};

export default class StrokeConfigBuilder {
  #config = cloneDeep(DEFAULT_STROKE_CONFIG);

  setWidth(width) {
    return this.#setProperty(ChartConfigPropertyKey.Width, width);
  }

  build() {
    return this.#config;
  }

  #setProperty(propertyName, value) {
    this.#config[propertyName] = value;

    return this;
  }
}
